const autoNgTemplateLoaderTemplate1 = require('./registry.html');

import angular from 'angular';
import controller from './registryController';

angular.module('portainer.app').component('editRegistry', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    $transition$: '<',
  },
});
